import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Menu, MenuList, MenuButton, MenuItem as MenuItem$1 } from '@chakra-ui/react';
import React, { useState } from 'react';
import { MenuItem, RegularMenuItem } from './menu-item.js';
import { Icon } from '../Icon/component.js';
var SubMenu = function SubMenu(_ref) {
  var menuItem = _ref.menuItem,
    items = _ref.items,
    isMenuItemOptions = _ref.isMenuItemOptions,
    checkboxChange = _ref.checkboxChange,
    selectionCount = _ref.selectionCount;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submenuOpen = _useState2[0],
    setSubmenuOpen = _useState2[1];
  var closeSubmenu = function closeSubmenu() {
    if (submenuOpen) {
      setSubmenuOpen(false);
    }
  };
  var toggleSubmenu = function toggleSubmenu() {
    setSubmenuOpen(!submenuOpen);
  };
  var submenuGroupTitle = function submenuGroupTitle(item) {
    var _item$itemConfig, _item$itemConfig2;
    var iconItem = _objectSpread2(_objectSpread2({}, item), {}, {
      itemConfig: {
        rightIconName: 'chevron-right'
      }
    });
    return /*#__PURE__*/React.createElement(MenuButton, {
      as: MenuItem$1,
      onClick: toggleSubmenu,
      closeOnSelect: false,
      icon: ((_item$itemConfig = item.itemConfig) === null || _item$itemConfig === void 0 ? void 0 : _item$itemConfig.iconName) && /*#__PURE__*/React.createElement(Icon, {
        iconName: (_item$itemConfig2 = item.itemConfig) === null || _item$itemConfig2 === void 0 ? void 0 : _item$itemConfig2.iconName
      })
    }, /*#__PURE__*/React.createElement(RegularMenuItem, {
      item: iconItem,
      selectionCount: selectionCount
    }));
  };
  return /*#__PURE__*/React.createElement(Menu, {
    closeOnSelect: false,
    isOpen: submenuOpen,
    placement: "right-end",
    onClose: closeSubmenu
  }, submenuGroupTitle(menuItem), /*#__PURE__*/React.createElement(MenuList, null, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: "".concat(item.text, "-").concat(item.value, "-").concat(index),
      index: index,
      item: item,
      isMenuItemOptions: isMenuItemOptions,
      checkboxChange: checkboxChange
    });
  })));
};
SubMenu.displayName = "SubMenu";
export { SubMenu };